export const BASE_AUTH_USER = 'user';
export const BASE_AUTH_TOKEN = 'token';
